import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    alignItems: 'flex-start',
    marginBottom: 16,
  },

  dattextAligne: {
    fontSize: 18,
    // marginBottom: 16,
    textAlign: 'left',
  },
  line: {
    height: 1,
    backgroundColor: '#D3D3D3', // Light gray
    width: '100%',
  },
  dateRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  todayBadge: {
    marginLeft: 8,
    backgroundColor: '#e6fae9',
    borderColor: '#b2e2b8',
    borderWidth: 1,
    borderRadius: 20,
    paddingHorizontal: 10,
    paddingVertical: 2,
  },

  todayText: {
    color: '#375019', // Your provided RGB color
    fontSize: 13,

    fontWeight: '600',
  },
});
